<template>
  <div>
    <div class="page-inner">
      <v-row v-if="request">
        <v-col lg="4" md="5" cols="12" v-if="request">
          <template v-if="canReview">
            <v-btn
              block
              color="success"
              class="mb-4"
              @click="openApproveDialog"
            >
              <v-icon left>mdi-check</v-icon>
              {{ $t('Принять') }}
            </v-btn>

            <v-btn block color="error" class="mb-4" @click="openRejectDialog">
              <v-icon left>mdi-close</v-icon>
              {{ $t('Отказать') }}
            </v-btn>
          </template>

          <v-btn
            v-if="canPrintOrder"
            block
            color="success"
            class="mb-4"
            @click="printOrder"
          >
            <v-icon left>mdi-printer</v-icon>
            {{ $t('Распечатать заявку') }}
          </v-btn>

          <v-dialog
            v-model="approveDialog"
            width="90vw"
            max-width="1600px"
            @keydown.esc="closeApproveDialog"
            persistent
          >
            <v-card class="dialog-card">
              <v-card-title class="headline">
                {{ $t('Рассмотрение заявки') }}
              </v-card-title>

              <v-divider />

              <v-card-text class="dialog-body">
                <v-row no-gutters style="">
                  <!-- Документ -->
                  <v-col cols="6" class="document-panel grey lighten-4">
                    <iframe
                      v-if="previewBlob"
                      :src="previewBlob"
                      width="100%"
                      height="100%"
                      frameborder="0"
                    />

                    <div
                      v-else
                      class="fill-height d-flex align-center justify-center"
                    >
                      {{ $t('Документ не найден') }}
                    </div>
                  </v-col>

                  <!-- Правая часть -->
                  <v-col cols="6" class="pa-5 grades-panel">
                    <h2 class="mb-4">
                      {{ $t('Оценивание') }}
                    </h2>

                    <v-select
                      v-model="subjectList.mainMode"
                      :items="languageGroupSelectItems"
                      item-text="text"
                      item-value="value"
                      :label="$t('Языковая группа')"
                    />

                    <div v-if="hasMainMode">
                      <v-row
                        v-for="item in subjectList.mainSubjects"
                        :key="item.subject_id"
                      >
                        <v-col cols="5">
                          <v-select
                            v-model="item.subject_id"
                            :items="mainAvailableSubjects"
                            item-text="name"
                            item-value="id"
                            readonly
                            append-icon=""
                            hide-details
                          />
                        </v-col>

                        <v-col cols="5">
                          <v-select
                            v-model="item.grade"
                            :items="gradeOptions"
                            item-text="text"
                            item-value="value"
                            :label="$t('Оценка')"
                            hide-details="auto"
                          />
                        </v-col>
                      </v-row>
                      <v-divider />
                    </div>
                    <h3>{{ $t('Остальные предметы') }}</h3>
                    <v-btn small color="primary" @click="addGrade">
                      {{ $t('+ Добавить предмет') }}
                    </v-btn>

                    <v-divider />

                    <v-row
                      v-for="(item, index) in requestData.grades"
                      :key="index"
                      class="mb-2"
                    >
                      <!-- Предмет -->
                      <v-col cols="5">
                        <v-select
                          v-model="item.subject_id"
                          :items="extraAvailableSubjects"
                          item-text="name"
                          item-value="id"
                          :label="$t('Предмет')"
                          hide-details="auto"
                        />
                      </v-col>

                      <!-- Оценка -->
                      <v-col cols="5">
                        <v-select
                          v-model="item.grade"
                          :items="gradeOptions"
                          item-text="text"
                          item-value="value"
                          :label="$t('Оценка')"
                          hide-details="auto"
                          required
                        />
                      </v-col>

                      <!-- Удалить -->
                      <v-col cols="2" class="d-flex align-center">
                        <v-btn icon @click="removeGrade(index)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <sign-ecp
                      @update-ecp-file-data="requestData.p12 = $event"
                      @update-ecp-password="requestData.password = $event"
                    />

                    <!-- сюда позже вставим форму -->
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider />
              <v-card-actions>
                <v-btn class="mb-2" text @click="closeApproveDialog">
                  {{ $t('Закрыть') }}
                </v-btn>
                <v-spacer />
                <v-btn class="mb-2" color="success" @click="submit">
                  {{ $t('Принять') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="rejectDialog"
            width="600"
            :persistent="rejectActionIsLoading"
            @keydown.esc="closeRejectDialog"
          >
            <v-card>
              <v-card-title class="headline">
                {{ $t('Отказ в заявке') }}
              </v-card-title>

              <v-card-text>
                <v-form ref="rejectForm">
                  <v-textarea
                    v-model="rejectReason"
                    :label="$t('Причина отказа')"
                    rows="3"
                    filled
                    auto-grow
                  />
                  <sign-ecp
                    :key="'sign-ecp-reject-' + rejectSignEcpKey"
                    @update-ecp-file-data="rejectEcpFileData = $event"
                    @update-ecp-password="rejectEcpPassword = $event"
                  />
                </v-form>
              </v-card-text>

              <v-divider />

              <v-card-actions>
                <v-btn text @click="closeRejectDialog">
                  {{ $t('Закрыть') }}
                </v-btn>
                <v-spacer />
                <v-btn
                  color="error"
                  text
                  :loading="rejectActionIsLoading"
                  @click="rejectSubmit"
                >
                  {{ $t('Отказать') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-divider />
          <v-card class="request-card">
            <v-card-title class="card-title">
              {{ $t('Информация о заявке') }}
            </v-card-title>

            <v-card-text class="pt-3 card-text-custom">
              <v-row class="mb-2">
                <v-col cols="5" class="label">{{ $t('Номер заявки') }}:</v-col>
                <v-col cols="7">{{ request.id }}</v-col>
              </v-row>

              <v-divider />

              <v-row class="mb-2">
                <v-col cols="5" class="label">{{ $t('Статус заявки') }}:</v-col>
                <v-col cols="7">
                  <v-chip small :color="statusColor(request.status)">
                    {{ translateMetadataLabel('status', request.status) }}
                  </v-chip>
                </v-col>
              </v-row>

              <template v-if="requestRejectReason">
                <v-divider />

                <v-row class="mb-2">
                  <v-col cols="5" class="label error--text">{{ $t('Причина отказа') }}:</v-col>
                  <v-col cols="7">{{ requestRejectReason }}</v-col>
                </v-row>
              </template>

              <v-divider />

              <v-row class="mb-2">
                <v-col cols="5" class="label"
                  >{{ $t('Категория заявителя') }}:</v-col
                >
                <v-col cols="7">{{
                  translateMetadataLabel('declarant_type', request.abiturient.declarant)
                }}</v-col>
              </v-row>

              <v-divider />

              <v-row class="mb-2">
                <v-col cols="5" class="label">{{ $t('ИИН') }}:</v-col>
                <v-col cols="7">{{ request.abiturient.abiturient_iin }}</v-col>
              </v-row>

              <v-divider />

              <v-row class="mb-2">
                <v-col cols="5" class="label"
                  >{{ $t('Электронная почта') }}:</v-col
                >
                <v-col cols="7">
                  {{ request.abiturient.abiturient_email }}
                </v-col>
              </v-row>

              <v-divider />

              <v-row class="mb-2">
                <v-col cols="5" class="label">{{ $t('Номер телефона') }}</v-col>
                <v-col cols="7">
                  {{ request.abiturient.abiturient_phone }}
                </v-col>
              </v-row>

              <v-divider />

              <v-row class="mb-2">
                <v-col cols="5" class="label">{{
                  $t('Номер телефона родителей')
                }}</v-col>
                <v-col cols="7">
                  {{ request.abiturient.parent_phone }}
                </v-col>
              </v-row>

              <v-divider />

              <v-row class="mb-2">
                <v-col cols="5" class="label">{{
                  $t('Тип образования')
                }}</v-col>
                <v-col cols="7">
                  {{
                    translateMetadataLabel('education_type', request.education.education_type)
                  }}
                </v-col>
              </v-row>

              <v-divider />

              <v-row class="mb-2">
                <v-col cols="5" class="label">{{ $t('Форма оплаты') }}</v-col>
                <v-col cols="7">
                  {{ translateMetadataLabel('payment_type', request.payment_type) }}
                </v-col>
              </v-row>

              <v-divider />

              <v-row class="mb-2">
                <v-col cols="5" class="label">{{ $t('Дата') }}</v-col>
                <v-col cols="7">
                  {{ formatDate(request.created_at) }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="8" md="7" cols="12" v-if="request">
          <!-- Личные данные -->
          <v-card class="request-card">
            <v-card-title class="card-title">
              {{ $t('Личные данные') }}
            </v-card-title>

            <v-card-text class="pt-3 card-text-custom">
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('ФИО') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ request.abiturient.abiturient_fio }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('Дата рождения') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ formatDate(request.abiturient.abiturient_date) }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('Гражданство') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{
                    translateMetadataLabel('citizen_status', request.abiturient.citizen_status)
                  }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('Национальность') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ translateLabel(request.abiturient.nationality) }}
                </v-col>
              </v-row>
              <v-divider v-if="request.abiturient.declarant == 2" />
              <v-row class="mb-2" v-if="request.abiturient.declarant == 2">
                <v-col cols="4" class="label">{{ $t('Родитель') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ request.abiturient.parent }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Образование -->
          <v-card class="request-card">
            <v-card-title class="card-title">
              {{ $t('Образование') }}
            </v-card-title>

            <v-card-text class="pt-3 card-text-custom">
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('Тип образования') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{
                    translateMetadataLabel('education_type', request.education.education_type)
                  }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row
                v-if="schoolEducationDisplay.showSchoolName"
                class="mb-2"
              >
                <v-col cols="4" class="label">{{ $t('Учебное заведение') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ schoolEducationDisplay.schoolName || '—' }}
                </v-col>
              </v-row>
              <v-divider v-if="schoolEducationDisplay.showSchoolName" />
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('Регион') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ schoolEducationDisplay.regionName || '—' }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('Страна') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ translateLabel(request.education.school_country) }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('Год окончания') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ request.education.graduation_year }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Документы -->
          <v-card class="request-card">
            <v-card-title class="card-title">
              {{ $t('Документы') }}
            </v-card-title>

            <v-card-text class="pt-3 card-text-custom">
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('Документ об образовании') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  <authenticated-file-link
                    v-if="request.documents.education_document_file_url"
                    :url="request.documents.education_document_file_url"
                  />
                </v-col>
              </v-row>
              <v-divider v-if="request.documents.quota_type" />
              <v-row class="mb-2" v-if="request.documents.quota_type">
                <v-col cols="4" class="label">{{ $t('Тип квоты') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                      {{request.documents.quota_type}}
                </v-col>
              </v-row>
              <v-divider v-if="request.documents.quota_type" />
              <v-row class="mb-2" v-if="request.documents.quota_type">
                <v-col cols="4" class="label">{{ $t('Квота') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  <authenticated-file-link
                    v-if="request.documents.quota_file_url"
                    :url="request.documents.quota_file_url"
                  />
                </v-col>
              </v-row>
              <v-divider />
              <v-row class="mb-2">
                <v-col cols="4" class="label"
                  >{{ $t('Медицинская справка 075/У (086)') }}</v-col
                >
                <v-spacer />
                <v-col cols="5">
                  <authenticated-file-link
                    v-if="request.documents.form_086_file_url"
                    :url="request.documents.form_086_file_url"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Квалификации -->
          <v-card
            v-for="item in request.request_qualifications"
            :key="item.id"
            class="request-card"
          >
            <v-card-title class="card-title">
              {{ $t('Квалификация №') }}{{ item.priority }}
            </v-card-title>

            <v-card-text class="pt-3 card-text-custom">
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('Колледж') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ item.college }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('Специальность') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ item.qualification?.specialty_name || '-' }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('Код специальности') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ item.qualification?.specialty_code || '-' }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('Квалификация') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ item.qualification?.name || '-' }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('Код квалификации') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ item.qualification?.qualification_code || '-' }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('Язык обучения') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ translateMetadataLabel('study_lang', item.study_lang) || '-' }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('Статус') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  <v-chip small :color="statusColor(item.status)">
                    {{ translateMetadataLabel('status', item.status) }}
                  </v-chip>
                </v-col>
              </v-row>
              <v-divider />
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('Целевой грант') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ item.is_target_grant ? $t('Да') : $t('Нет') }}
                </v-col>
              </v-row>
              <v-divider />
              <template v-if="item.exams">
                <div class="mt-6 mb-6" v-for="ex in item.exams" :key="ex.id">
                  {{ translateLabel(ex.exam_type) }}

                  <v-row class="mt-4 mb-4">
                    <v-col cols="4" class="label">{{ $t('Адрес') }}</v-col>
                    <v-spacer />
                    <v-col cols="5">
                      {{ ex.exam_address }}
                    </v-col>
                  </v-row>

                  <v-row class="mt-4 mb-4">
                    <v-col cols="4" class="label">{{ $t('Дата и время') }}</v-col>
                    <v-spacer />
                    <v-col cols="5">
                      {{ ex.exam_date }}
                    </v-col>
                  </v-row>

                  <v-row class="mt-4 mb-4">
                    <v-col cols="4" class="label">{{ $t('Оценка') }}</v-col>
                    <v-spacer />
                    <v-col cols="5">
                      {{ ex.grade ? ex.grade : '-' }}
                    </v-col>
                  </v-row>
                  <v-divider />
                </div>
              </template>
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('СБА') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ item?.asc || '-' }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row class="mb-2">
                <v-col cols="4" class="label">{{ $t('СКБ') }}</v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ item?.acs || '-' }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row
                class="mb-2 justify-center"
                v-if="item.have_exams && item.status == 4"
              >
                <v-col cols="6" class="label">
                  <v-btn
                    block
                    color="primary"
                    class="mb-4"
                    @click="openExamDialog(item)"
                  >
                    <v-icon left>mdi-calendar-clock</v-icon>
                    {{ $t('Назначить экзамен') }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row
                class="mb-2 justify-center"
                v-if="item.have_exams && item.status == 5"
              >
                <v-col cols="6" class="label">
                  <v-btn
                    block
                    color="primary"
                    class="mb-4"
                    @click="getExams(item)"
                  >
                    <v-icon left>mdi-check</v-icon>
                    {{ $t('Поставить оценку экзамена') }}
                  </v-btn>
                </v-col>
              </v-row>
							<v-row
                class="mb-2 justify-center"
                v-if="item.have_exams && item.status == 6"
              >
                <v-col cols="6" class="label">
                  <v-btn
                    block
                    color="primary"
                    class="mb-4"
                    @click="openAcsGradeDialog(item)"
                  >
                    <v-icon left>mdi-check</v-icon>
                    {{ $t('Поставить оценку СКБ') }}
                  </v-btn>
                </v-col>
              </v-row>

            </v-card-text>
          </v-card>

          <!-- Диалог для назначения экзамена -->
          <v-dialog v-model="examDialog" width="50vw" max-width="700">
            <v-card class="dialog-card" outlined>
              <v-card-title>{{ $t('Назначение экзаменов') }}</v-card-title>
              <v-divider />
              <v-card-text>
                <v-form ref="examForm">
                  <div v-for="exam in exams" :key="exam.id">
                    <h3>
                      <strong>{{ exam.name }}</strong>
                    </h3>
                    <v-divider />
                    <v-row>
                      <v-col cols="6">
                        <v-menu
                          v-model="exam.dateMenu"
                          :close-on-content-click="false"
                          offset-y
                          max-width="290"
                        >
                          <template v-slot:activator="{on, attrs}">
                            <v-text-field
                              v-model="exam.date"
                              :label="$t('Дата проведения')"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              outlined
                              v-bind="attrs"
                              v-on="on"
                            />
                          </template>

                          <v-date-picker
                            v-model="exam.date"
                            @input="exam.dateMenu = false"
                          />
                        </v-menu>
                      </v-col>

                      <v-col cols="6">
                        <v-text-field
                          :value="exam.time"
                          :label="$t('Время (HH:mm)')"
                          placeholder="14:30"
                          prepend-inner-icon="mdi-clock-outline"
                          outlined
                          maxlength="5"
                          :rules="[validateExamTime]"
                          @input="onExamTimeInput(exam, $event)"
                        />
                      </v-col>
                    </v-row>

                    <v-text-field
                      v-model="exam.exam_address"
                      :label="$t('Место проведения')"
                    />
                    <v-divider />
                  </div>
                </v-form>
              </v-card-text>
              <v-divider />
              <v-card-actions>
                <v-btn text @click="closeExamDialog()">{{ $t('Закрыть') }}</v-btn>
                <v-spacer />
                <v-btn color="primary" text @click="setExams()">
                  {{ $t('Назначить') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Диалог для выставки оценок экзамена -->
          <v-dialog v-model="gradeExDialog" width="70vw" max-width="1000">
            <v-card class="dialog-exam-card" outlined>
              <v-card-title class="card-title"
                >{{ $t('Оценка экзаменов') }}</v-card-title
              >
              <v-card-text class="mt-5">
                <div v-for="i in gradeExams" :key="i.id">
                  <v-row>
                    <v-col cols="9" class="label">
                      {{ i.exam_type }}
                    </v-col>
                    <v-col cols="3">
                      <v-select
                        :items="getGradesByType(i.grade_type)"
                        v-model="i.grade"
                      />
                    </v-col>
                  </v-row>
                  <v-divider />
                </div>
                <v-card-actions>
                  <v-btn text @click="gradeExDialog = false">
                    {{ $t('Закрыть') }}
                  </v-btn>
                  <v-spacer />
                  <v-btn color="primary" text @click="setExamGrades()">
                    {{ $t('Назначить') }}
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-card>
          </v-dialog>

          <!-- Диалог для выставки оценок СКБ -->
          <v-dialog
            v-model="acsGradeDialog"
            width="70vw"
            max-width="1000"
            :persistent="acsGradeActionIsLoading"
          >
            <v-card class="dialog-exam-card" outlined>
              <v-card-title class="card-title">
                {{ $t('Оценки СКБ') }}
              </v-card-title>
              <v-card-text class="mt-5">
                <v-progress-linear
                  v-if="acsGradeLoading"
                  indeterminate
                  color="primary"
                  class="mb-4"
                />
                <template v-else>
                    <v-form
                      v-if="acsGradeSubjects.length"
                      ref="acsGradeForm"
                    >
                      <div
                        v-for="row in acsGradeSubjects"
                        :key="row.gradeKey"
                      >
                        <v-row align="center">
                          <v-col cols="4" class="label">
                            {{ getAcsGradeRowLabel(row) }}
                          </v-col>
                        
                          <v-col cols="5">
                            <v-select
                              v-model="row.selectedSubjectId"
                              :items="row.options"
                              item-text="name"
                              item-value="id"
                              :label="$t('Предмет')"
                              :disabled="!row.options.length"
                              :rules="getAcsSubjectSelectRules(row)"
                              clearable
                            />
                          </v-col>
                        
                          <v-col cols="3">
                            <v-text-field
                              :value="getAcsSelectedGrade(row)"
                              :label="$t('Оценка')"
                              readonly
                              outlined
                              dense
                              hide-details="auto"
                            />
                          </v-col>
                        </v-row>
                      
                        <v-divider />
                      </div>
                    </v-form>
                  
                    <div
                      v-else
                      class="text-center py-10 grey--text text--darken-1"
                    >
                      {{ $t('СКБ формула не настроена!') }}
                    </div>
                  </template>
              </v-card-text>
              <v-divider />
              <v-card-actions>
                <v-btn text @click="closeAcsGradeDialog">
                  {{ $t('Закрыть') }}
                </v-btn>
                <v-spacer />
                <v-btn
                  color="primary"
                  text
                  :loading="acsGradeActionIsLoading"
                  :disabled="acsGradeLoading || !acsGradeSubjects.length"
                  @click="setAcsGrades"
                >
                  {{ $t('Сохранить') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Оценки -->
          <v-card
            v-if="request.certificate_grades?.length"
            class="request-card"
          >
            <v-card-title class="card-title">{{ $t('Оценки аттестата') }}</v-card-title>

            <v-card-text
              class="pt-3 card-text-custom"
              v-for="certificate in request.certificate_grades"
              :key="certificate.subject_id"
            >
              <v-row class="mb-2">
                <v-col cols="4" class="label">
                  {{ translateLabel(certificate.subject) }}
                </v-col>
                <v-spacer />
                <v-col cols="5">
                  {{ certificate.grade }}
                </v-col>
              </v-row>
              <v-divider />
            </v-card-text>

            <v-card-actions v-if="canEditCertificateGrades" class="justify-center pb-4">
              <v-btn color="primary" @click="openEditAseGradesDialog">
                <v-icon left>mdi-pencil</v-icon>
                {{ $t('Редактировать') }}
              </v-btn>
            </v-card-actions>
          </v-card>

          <v-dialog
            v-model="editAseGradesDialog"
            width="90vw"
            max-width="1600px"
            :persistent="editAseGradesSubmitting"
            @keydown.esc="closeEditAseGradesDialog"
          >
            <v-card class="dialog-card">
              <v-card-title class="headline">
                {{ $t('Редактирование оценок аттестата') }}
              </v-card-title>

              <v-divider />

              <v-card-text class="dialog-body">
                <v-row no-gutters>
                  <v-col cols="6" class="document-panel grey lighten-4">
                    <iframe
                      v-if="editAsePreviewBlob"
                      :src="editAsePreviewBlob"
                      width="100%"
                      height="100%"
                      frameborder="0"
                    />

                    <div
                      v-else
                      class="fill-height d-flex align-center justify-center"
                    >
                      {{ $t('Документ не найден') }}
                    </div>
                  </v-col>

                  <v-col cols="6" class="pa-5 grades-panel">
                    <h2 class="mb-4">
                      {{ $t('Оценивание') }}
                    </h2>

                    <v-select
                      v-model="editAseSubjectList.mainMode"
                      :items="languageGroupSelectItems"
                      item-text="text"
                      item-value="value"
                      :label="$t('Языковая группа')"
                      :loading="editAseSubjectsLoading"
                    />

                    <div v-if="editAseHasMainMode">
                      <v-row
                        v-for="item in editAseSubjectList.mainSubjects"
                        :key="item.subject_id"
                      >
                        <v-col cols="5">
                          <v-select
                            v-model="item.subject_id"
                            :items="editAseMainAvailableSubjects"
                            item-text="name"
                            item-value="id"
                            readonly
                            append-icon=""
                            hide-details
                          />
                        </v-col>

                        <v-col cols="5">
                          <v-select
                            v-model="item.grade"
                            :items="gradeOptions"
                            item-text="text"
                            item-value="value"
                            :label="$t('Оценка')"
                            hide-details="auto"
                            clearable
                          />
                        </v-col>
                      </v-row>
                      <v-divider />
                    </div>

                    <h3>{{ $t('Остальные предметы') }}</h3>
                    <v-btn small color="primary" class="mb-3" @click="addEditAseGrade">
                      {{ $t('+ Добавить предмет') }}
                    </v-btn>

                    <v-divider />

                    <v-row
                      v-for="(item, index) in editAseGrades"
                      :key="item.rowKey"
                      class="mb-2"
                    >
                      <v-col cols="5">
                        <v-select
                          v-model="item.subject_id"
                          :items="getEditAseExtraAvailableSubjects(item)"
                          item-text="name"
                          item-value="id"
                          :label="$t('Предмет')"
                          hide-details="auto"
                        />
                      </v-col>

                      <v-col cols="5">
                        <v-select
                          v-model="item.grade"
                          :items="gradeOptions"
                          item-text="text"
                          item-value="value"
                          :label="$t('Оценка')"
                          hide-details="auto"
                          clearable
                        />
                      </v-col>

                      <v-col cols="2" class="d-flex align-center">
                        <v-btn icon @click="removeEditAseGrade(index)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-divider />

                    <sign-ecp
                      :key="'sign-ecp-edit-ase-' + editAseSignEcpKey"
                      @update-ecp-file-data="editAseEcpFileData = $event"
                      @update-ecp-password="editAseEcpPassword = $event"
                    />
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider />

              <v-card-actions>
                <v-btn text @click="closeEditAseGradesDialog">
                  {{ $t('Закрыть') }}
                </v-btn>
                <v-spacer />
                <v-btn
                  color="success"
                  :loading="editAseGradesSubmitting"
                  :disabled="!hasEditAseGradeChanges"
                  @click="submitEditAseGrades"
                >
                  {{ $t('Сохранить') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import AuthenticatedFileLink from '@/components/abiturient/AuthenticatedFileLink.vue'
import { buildAseEditRequest, buildRejectOrderFormData, buildAcsOrderRequestParams, buildGradeAcsOrderPayload, createAseGradesSnapshot, getAcsGradeModalSelectedGrade, hasAseGradeChanges, hasAcsGradeRowName, mapAcsGradeModalRows } from '@/utils/college'
import { getMetadataLabel, getSchoolEducationDisplayInfo, normalizeRegionListResponse, normalizeRegions } from '@/utils/metadata'
import {
  buildCollegeOrderPrintHtml,
  formatCollegeOrderPrintContactPhone,
  formatCollegeOrderPrintDateTime,
  formatCollegeOrderPrintQualification,
  hasCollegeOrderAdmissionQuota,
  isCollegeOrderAccepted,
  openCollegeOrderPrint,
} from '@/utils/orderPrint'

export default {
  components: {
    AuthenticatedFileLink,
  },

  data: () => ({
    subjectsLoading: false,
    loading: false,

    request: null,
    metadata: null,
    regionList: [],

    approveDialog: false,
    rejectDialog: false,
    rejectReason: '',
    rejectEcpFileData: null,
    rejectEcpPassword: null,
    rejectActionIsLoading: false,
    rejectSignEcpKey: 0,
    documentUrl: null,
    previewBlob: null,
    requestQualificationId: null,

    subjects: [],
    subjectList: {
      mainMode: null,
      mainSubjects: [],
      extraSubjects: [
        {
          subject_id: null,
          value: null,
        },
      ],
    },
    requestData: {
      grades: [
        {
          subject_id: null,
          grade: null,
        },
      ],
      password: null,
      ecp: null,
    },
    examDialog: false,
    exams: [],
    gradeExams: [
      {
        id: null,
        grade: null,
      },
    ],
    gradeExDialog: false,
    acsGradeDialog: false,
    acsGradeSubjects: [],
    acsGradeLoading: false,
    acsGradeActionIsLoading: false,
    editAseGradesDialog: false,
    editAsePreviewBlob: null,
    editAseSubjectsLoading: false,
    editAseGradesSubmitting: false,
    editAseSignEcpKey: 0,
    editAseEcpFileData: null,
    editAseEcpPassword: null,
    editAseOriginalSnapshot: '',
    editAseSubjectList: {
      mainMode: null,
      mainSubjects: [],
    },
    editAseGrades: [],
  }),

  async mounted() {
    await this.loadMetadata()
    await this.loadRegions()
    await this.fetchRequest()
  },

  computed: {
    certificateLanguageGroups() {
      const groups = new Set()

      this.subjects.forEach((subject) => {
        if (subject.group && subject.group !== 'HIS') {
          groups.add(subject.group)
        }
      })

      return Array.from(groups).sort()
    },

    languageGroupSelectItems() {
      return [
        { text: this.$t('Выбрать'), value: null },
        ...this.certificateLanguageGroups.map((group) => ({
          text: group,
          value: group,
        })),
      ]
    },

    gradeOptions() {
      if (!this.metadata?.grade) return []

      return this.metadata.grade
        .map((label, key) => ({
          text: label,
          value: key,
        }))
        .filter((item) => item.value >= 3)
    },

    // RU/KZ предметы
    mainAvailableSubjects() {
      if (!this.isCertificateLanguageGroup(this.subjectList.mainMode)) {
        return []
      }

      return this.subjects.filter((subject) => subject.group === this.subjectList.mainMode)
    },

    hasMainMode() {
      return this.isCertificateLanguageGroup(this.subjectList.mainMode)
    },

    extraAvailableSubjects() {
      return this.subjects.filter(
        (subject) => !subject.group || subject.group === 'HIS',
      )
    },

    currentQualification() {
      return this.request?.request_qualifications?.find((q) => q.is_mine)
    },

    requestRejectReason() {
      const qualification = this.currentQualification
        || this.request?.request_qualifications?.find((item) => item.reject_reason)

      const reason = qualification?.reject_reason
      if (reason == null || !String(reason).trim()) {
        return null
      }

      return String(reason).trim()
    },

    canReview() {
      return this.currentQualification?.status === 1
    },

    canPrintOrder() {
      return isCollegeOrderAccepted(this.request)
    },

    canEditCertificateGrades() {
      // return !!this.request?.certificate_grades?.length
      //   && this.currentQualification?.status === 4
      return true
    },

    editAseMainAvailableSubjects() {
      if (!this.isCertificateLanguageGroup(this.editAseSubjectList.mainMode)) {
        return []
      }

      return this.subjects.filter((subject) => subject.group === this.editAseSubjectList.mainMode)
    },

    editAseHasMainMode() {
      return this.isCertificateLanguageGroup(this.editAseSubjectList.mainMode)
    },

    editAseGradesPayload() {
      const rows = []
      const seenSubjectIds = new Set()

      const appendRow = (subjectId, grade) => {
        if (subjectId == null || seenSubjectIds.has(String(subjectId))) {
          return
        }

        seenSubjectIds.add(String(subjectId))
        rows.push({
          certificate_predmet_id: subjectId,
          grade,
        })
      }

      this.editAseSubjectList.mainSubjects.forEach((item) => {
        appendRow(item.subject_id, item.grade)
      })

      this.editAseGrades.forEach((item) => {
        appendRow(item.subject_id, item.grade)
      })

      return rows
    },

    hasEditAseGradeChanges() {
      return hasAseGradeChanges(this.editAseOriginalSnapshot, this.editAseGradesPayload)
    },

    schoolEducationDisplay() {
      if (!this.request) {
        return {
          regionName: '',
          schoolName: '',
          showSchoolName: false,
        }
      }

      return getSchoolEducationDisplayInfo(this.request, this.regionList)
    },
  },

  watch: {
    '$route.params.id': {
      async handler(newId, oldId) {
        if (!newId || newId === oldId) {
          return
        }

        this.resetPageState()
        await this.loadRegions()
        await this.fetchRequest()
      },
    },

    'subjectList.mainMode'(val) {
      if (!this.isCertificateLanguageGroup(val)) {
        this.subjectList.mainSubjects = []
        return
      }

      this.subjectList.mainSubjects = this.buildMainSubjectsForLanguageGroup(val)
    },

    'editAseSubjectList.mainMode'(val) {
      if (!this.editAseGradesDialog) {
        return
      }

      if (!this.isCertificateLanguageGroup(val)) {
        this.editAseSubjectList.mainSubjects = []
        return
      }

      const gradeBySubjectId = {}
      this.editAseGradesPayload.forEach((item) => {
        gradeBySubjectId[String(item.certificate_predmet_id)] = item.grade
      })

      this.editAseSubjectList.mainSubjects = this.buildMainSubjectsForLanguageGroup(
        val,
        gradeBySubjectId,
      )
    },
  },

  methods: {
    resetPageState() {
      this.request = null
      this.closeApproveDialog()
      this.closeExamDialog()
      this.rejectDialog = false
      this.resetRejectDialogState()
      this.gradeExDialog = false
      this.gradeExams = []
      this.closeAcsGradeDialog()
      this.closeEditAseGradesDialog()
      this.requestQualificationId = null
    },

    translateLabel(value) {
      if (value == null || value === '') {
        return ''
      }
      return this.$t(String(value))
    },

    isCertificateLanguageGroup(value) {
      return value != null
        && value !== ''
        && this.certificateLanguageGroups.includes(value)
    },

    buildMainSubjectsForLanguageGroup(group, gradeBySubjectId = {}) {
      return this.subjects
        .filter((subject) => subject.group === group)
        .map((subject) => ({
          subject_id: subject.id,
          grade: gradeBySubjectId[String(subject.id)] ?? null,
        }))
    },

    createEditAseGradeRow({ subject_id = null, grade = null, rowKey = null } = {}) {
      return {
        rowKey: rowKey || `ase-grade-${Date.now()}-${Math.random().toString(36).slice(2)}`,
        subject_id,
        grade,
      }
    },

    getEditAseExtraAvailableSubjects(row) {
      const usedSubjectIds = new Set()

      this.editAseSubjectList.mainSubjects.forEach((item) => {
        if (item.subject_id != null) {
          usedSubjectIds.add(String(item.subject_id))
        }
      })

      this.editAseGrades.forEach((item) => {
        if (item !== row && item.subject_id != null) {
          usedSubjectIds.add(String(item.subject_id))
        }
      })

      return this.subjects.filter((subject) => (
        (!subject.group || subject.group === 'HIS')
        && !usedSubjectIds.has(String(subject.id))
      ))
    },

    detectLanguageGroupFromGrades(gradeBySubjectId) {
      return this.certificateLanguageGroups.find((group) => (
        this.subjects
          .filter((subject) => subject.group === group)
          .some((subject) => gradeBySubjectId[String(subject.id)] != null)
      )) || null
    },

    translateMetadataLabel(metadataKey, value) {
      if (value == null || value === '') {
        return ''
      }

      let label = value
      const meta = this.metadata && this.metadata[metadataKey]

      if (meta) {
        const fromMeta = getMetadataLabel(meta, value)
        if (fromMeta) {
          label = fromMeta
        }
      }

      return this.$t(String(label))
    },

    printOrder() {
      if (!this.request) {
        return
      }

      const sortedQualifications = [...(this.request.request_qualifications || [])]
        .sort((left, right) => Number(left.priority || 0) - Number(right.priority || 0))

      const html = buildCollegeOrderPrintHtml({
        t: this.$t.bind(this),
        printedAt: formatCollegeOrderPrintDateTime(),
        fullName: this.request.abiturient?.abiturient_fio || '—',
        iin: this.request.abiturient?.abiturient_iin || '—',
        contactPhone: formatCollegeOrderPrintContactPhone(this.request),
        educationType: this.translateMetadataLabel(
          'education_type',
          this.request.education?.education_type,
        ) || '—',
        hasAdmissionQuota: hasCollegeOrderAdmissionQuota(this.request, this.$t.bind(this)),
        submittedViaLabel: this.$t('Подано через ИС Абитуриент EDUS'),
        qualifications: sortedQualifications.map((item, index) => (
          formatCollegeOrderPrintQualification(
            item,
            Number(item.priority) || index + 1,
            (studyLang) => this.translateMetadataLabel('study_lang', studyLang),
          )
        )),
      });

      openCollegeOrderPrint(html);
    },

    async fetchRequest() {
      this.loading = true

      try {
        const id = this.$route.params.id

        const res = await this.$http.get('/info-order', {
          params: {id},
        })

        this.request = res.data.data

        await this.loadUploadLinks()
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    async loadMetadata() {
      this.loading = true

      try {
        const {data} = await this.$http.get('/metadata')

        this.metadata = data
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    async loadRegions() {
      try {
        const {data} = await this.$http.get('/regions')
        this.regionList = normalizeRegions(normalizeRegionListResponse(data))
      } catch (e) {
        console.error(e)
        this.regionList = []
      }
    },

    formatDate(dateString) {
      return new Intl.DateTimeFormat('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(new Date(dateString))
    },

    statusColor(status) {
      switch (status) {
        case 4:
        case 7:
          return 'success'

        case 2:
        case 8:
        case 3:
          return 'error'

        case 5:
        case 6:
        case 9:
          return 'info'

        default:
          return 'primary'
      }
    },

    async loadPreview(url) {
      const response = await this.$http.get(url, {
        responseType: 'blob',
        silent: true,
      })

      this.previewBlob = URL.createObjectURL(response.data)
    },

    async loadEditAsePreview(url) {
      this.clearEditAsePreview()

      if (!url) {
        return
      }

      try {
        const response = await this.$http.get(url, {
          responseType: 'blob',
          silent: true,
        })

        this.editAsePreviewBlob = URL.createObjectURL(response.data)
      } catch (error) {
        console.error('edit ase preview load error', error)
        this.editAsePreviewBlob = null
      }
    },

    clearEditAsePreview() {
      if (this.editAsePreviewBlob) {
        URL.revokeObjectURL(this.editAsePreviewBlob)
        this.editAsePreviewBlob = null
      }
    },

    async loadUploadLinks() {
      try {
        if (!this.request || !this.request.documents) return

        const payload = {
          document_file: this.request.documents.education_document_file,
          form_086: this.request.documents.form_086_file,
          quota: this.request.documents.quota_file,
        }

        const res = await this.$http.post('/uploads', payload)

        const links = res.data.data

        this.$set(
          this.request.documents,
          'education_document_file_url',
          links.document_file,
        )
        this.$set(this.request.documents, 'form_086_file_url', links.form_086)
        this.$set(this.request.documents, 'quota_file_url', links.quota)
      } catch (e) {
        console.error('upload links error', e)
      }
    },

    async loadSubjects(educationTypeId) {
      if (!educationTypeId) return

      this.subjectsLoading = true

      try {
        const res = await this.$http.get('/certificate-subjects', {
          params: {
            education_type: educationTypeId,
          },
        })

        this.subjects = res.data.data || []
      } catch (e) {
        console.error('subjects load error', e)
        this.subjects = []
      } finally {
        this.subjectsLoading = false
      }
    },

    async openApproveDialog() {
      this.documentUrl = this.request.documents.education_document_file_url
      this.previewBlob = null
      this.approveDialog = true

      this.loadPreview(this.documentUrl)
      await this.loadSubjects(this.request.education.education_type)
    },

    openRejectDialog() {
      this.rejectReason = ''
      this.rejectEcpFileData = null
      this.rejectEcpPassword = null
      this.rejectSignEcpKey += 1
      this.rejectDialog = true
    },

    closeRejectDialog() {
      if (this.rejectActionIsLoading) {
        return
      }

      this.rejectDialog = false
      this.resetRejectDialogState()
    },

    resetRejectDialogState() {
      this.rejectReason = ''
      this.rejectEcpFileData = null
      this.rejectEcpPassword = null
    },

    async rejectSubmit() {
      if (!this.$refs.rejectForm.validate()) {
        return
      }

      this.rejectActionIsLoading = true

      try {
        const formData = buildRejectOrderFormData({
          id: this.request.id,
          reject_reason: this.rejectReason,
          ecp: this.rejectEcpFileData,
          password: this.rejectEcpPassword,
        })

        const response = await this.$http.post('/reject-order', formData)
        const message =
          (response.data && response.data.message) ||
          this.$t('Заявка отклонена.')

        this.$store.dispatch('alertAdd', {
          text: message,
          type: 'success',
        })

        this.rejectDialog = false
        this.resetRejectDialogState()
        await this.fetchRequest()
      } catch (e) {
        console.error(e)
      } finally {
        this.rejectActionIsLoading = false
      }
    },

    closeApproveDialog() {
      this.approveDialog = false

      if (this.previewBlob) {
        URL.revokeObjectURL(this.previewBlob)
        this.previewBlob = null
      }

      this.documentUrl = null
    },

    addGrade() {
      this.requestData.grades.push({
        subject_id: null,
        grade: null,
      })
    },

    removeGrade(index) {
      this.requestData.grades.splice(index, 1)
    },

    async loadEditAseSubjects(educationTypeId) {
      if (!educationTypeId) {
        return
      }

      this.editAseSubjectsLoading = true

      try {
        const response = await this.$http.get('/certificate-subjects', {
          params: {
            education_type: educationTypeId,
          },
        })

        this.subjects = response.data.data || []
      } catch (error) {
        console.error('subjects load error', error)
        this.subjects = []
      } finally {
        this.editAseSubjectsLoading = false
      }
    },

    initializeEditAseGradesFromRequest() {
      const certificateGrades = this.request.certificate_grades || []
      const gradeBySubjectId = {}

      certificateGrades.forEach((gradeItem) => {
        const subjectId = gradeItem.subject_id ?? gradeItem.certificate_predmet_id
        if (subjectId != null) {
          gradeBySubjectId[String(subjectId)] = gradeItem.grade
        }
      })

      let mainMode = this.detectLanguageGroupFromGrades(gradeBySubjectId)

      this.editAseSubjectList.mainMode = mainMode

      if (mainMode) {
        this.editAseSubjectList.mainSubjects = this.buildMainSubjectsForLanguageGroup(
          mainMode,
          gradeBySubjectId,
        )
      } else {
        this.editAseSubjectList.mainSubjects = []
      }

      const mainSubjectIds = new Set(
        this.editAseSubjectList.mainSubjects.map((item) => String(item.subject_id)),
      )

      this.editAseGrades = certificateGrades
        .filter((gradeItem) => {
          const subjectId = String(gradeItem.subject_id ?? gradeItem.certificate_predmet_id)
          return !mainSubjectIds.has(subjectId)
        })
        .map((gradeItem) => this.createEditAseGradeRow({
          rowKey: `ase-grade-${gradeItem.subject_id ?? gradeItem.certificate_predmet_id}`,
          subject_id: gradeItem.subject_id ?? gradeItem.certificate_predmet_id,
          grade: gradeItem.grade,
        }))

      if (!this.editAseGrades.length) {
        this.editAseGrades = [this.createEditAseGradeRow()]
      }
    },

    async openEditAseGradesDialog() {
      this.editAseEcpFileData = null
      this.editAseEcpPassword = null
      this.editAseSignEcpKey += 1
      this.editAseGradesDialog = true
      this.clearEditAsePreview()
      this.loadEditAsePreview(this.request.documents?.education_document_file_url)

      await this.loadEditAseSubjects(this.request.education.education_type)
      this.initializeEditAseGradesFromRequest()
      this.editAseOriginalSnapshot = createAseGradesSnapshot(this.editAseGradesPayload)
    },

    closeEditAseGradesDialog() {

      this.editAseGradesDialog = false
      this.clearEditAsePreview()
      this.editAseEcpFileData = null
      this.editAseEcpPassword = null
      this.editAseOriginalSnapshot = ''
      this.editAseSubjectList = {
        mainMode: null,
        mainSubjects: [],
      }
      this.editAseGrades = []
    },

    addEditAseGrade() {
      this.editAseGrades.push(this.createEditAseGradeRow())
    },

    removeEditAseGrade(index) {
      this.editAseGrades.splice(index, 1)

      if (!this.editAseGrades.length) {
        this.editAseGrades = [this.createEditAseGradeRow()]
      }
    },

    async submitEditAseGrades() {
      if (!this.hasEditAseGradeChanges) {
        return
      }

      if (!this.editAseEcpFileData || !this.editAseEcpPassword) {
        this.$store.dispatch('alertAdd', {
          text: this.$t('Выберите ЭЦП и введите пароль'),
          type: 'error',
        })
        return
      }

      this.editAseGradesSubmitting = true

      try {
        const originalRows = JSON.parse(this.editAseOriginalSnapshot)
        const { formData, params } = buildAseEditRequest({
          id: this.request.id,
          originalRows,
          currentRows: this.editAseGradesPayload,
          ecp: this.editAseEcpFileData,
          password: this.editAseEcpPassword,
        })

        const response = await this.$http.post('/ase-edit', formData, { params })
        const message = (response.data && response.data.message)
          || this.$t('Оценки аттестата обновлены')

        this.$store.dispatch('alertAdd', {
          text: message,
          type: 'success',
        })

        this.closeEditAseGradesDialog()
        await this.fetchRequest()
      } catch (error) {
        console.error(error)
      } finally {
        this.editAseGradesSubmitting = false
      }
    },

    getGradesPayload() {
      const main = this.subjectList.mainSubjects.map((i) => ({
        certificate_predmet_id: i.subject_id,
        grade: i.grade,
      }))

      const extra = this.requestData.grades.map((i) => ({
        certificate_predmet_id: i.subject_id,
        grade: i.grade,
      }))

      return [...main, ...extra]
    },

    async submit() {
      try {
        const payload = {
          request_id: this.request.id,
          grades: this.getGradesPayload(),
          ecp: this.requestData.p12,
          password: this.requestData.password,
        }

        const response = await this.$http.post('/accept-order', payload)

        await this.fetchRequest()

        this.closeApproveDialog()

        this.$store.dispatch('alertAdd', {
          text: response.data.message,
          type: 'success',
        })
      } catch (e) {
        console.error(e)
      }
    },

    validateExamTime(value) {
      if (!value || !String(value).trim() || String(value).trim() === ':') {
        return this.$t('Обязательное поле')
      }

      return (
        /^([01]\d|2[0-3]):[0-5]\d$/.test(String(value).trim()) ||
        this.$t('Укажите время в формате ЧЧ:мм')
      )
    },

    onExamTimeInput(exam, value) {
      if (!value || value === ':') {
        exam.time = ':'
        return
      }

      const digits = String(value).replace(/\D/g, '').slice(0, 4)

      if (!digits.length) {
        exam.time = ':'
        return
      }

      if (digits.length <= 2) {
        exam.time = `${digits}:`
      } else {
        exam.time = `${digits.slice(0, 2)}:${digits.slice(2)}`
      }
    },

    async openExamDialog(item) {
      try {
        if (this.examDialog) return

        this.requestQualificationId = item.id

        const {data} = await this.$http.get('/info-exams', {
          params: buildAcsOrderRequestParams({
            item,
            request: this.request,
          }),
        })

        this.exams = (data.data || []).map((exam) => ({
          ...exam,
          time: exam.time || ':',
        }))
        this.examDialog = true
      } catch (e) {
        console.error(e)
      }
    },

    async closeExamDialog() {
      this.examDialog = false
      this.requestQualificationId = null
      this.exams = []
      this.$refs.examForm?.resetValidation()
    },

    async setExams() {
      const examForm = this.$refs.examForm

      if (!examForm || !examForm.validate()) {
        return
      }

      try {
        const payload = {
          exams: this.exams.map((exam) => ({
            req_id: this.requestQualificationId,
            exam_type: exam.id,
            exam_date: `${exam.date} ${String(exam.time).trim()}:00`,
            exam_address: exam.exam_address,
          })),
        }

        const response = await this.$http.post('set-exams', payload)

        this.examDialog = false

        await this.fetchRequest()

        this.$store.dispatch('alertAdd', {
          text: response.data.message,
          type: 'success',
        })
      } catch (e) {
        console.error(e)
      }
    },

    async getExams(item) {
      try {
        if (this.gradeExDialog) return

        const {data} = await this.$http.get('/get-exams', {
          params: {id: item.id},
        })

        this.gradeExams = data.data || []

        this.gradeExDialog = true
      } catch (e) {
        console.error(e)
      }
    },

    async setExamGrades() {
      try {
        const payload = this.gradeExams.map((i) => ({
          exam_id: i.id,
          grade: i.grade ?? null,
        }))

        const response = await this.$http.post('/grade-exams', {
          exams: payload,
        })

        this.gradeExDialog = false

        await this.fetchRequest()

        this.$store.dispatch('alertAdd', {
          text: response.data.message,
          type: 'success',
        })
      } catch (e) {
        console.error(e)
      }
    },

    async openAcsGradeDialog(item) {
      if (this.acsGradeDialog || this.acsGradeLoading) {
        return
      }

      this.requestQualificationId = item.id
      this.acsGradeSubjects = []
      this.acsGradeDialog = true
      this.acsGradeLoading = true

      try {
        const {data} = await this.$http.get('/acs-order', {
          params: buildAcsOrderRequestParams({
            item,
            request: this.request,
          }),
        })

        this.acsGradeSubjects = mapAcsGradeModalRows(data.data)
      } catch (e) {
        console.error(e)
        this.closeAcsGradeDialog()
      } finally {
        this.acsGradeLoading = false
      }
    },

    closeAcsGradeDialog() {

      this.acsGradeDialog = false
      this.acsGradeSubjects = []
      this.acsGradeLoading = false
      this.requestQualificationId = null
      this.$refs.acsGradeForm?.resetValidation()
    },

    getAcsGradeRowLabel(row) {
      return hasAcsGradeRowName(row.name)
        ? this.translateLabel(row.name)
        : '—'
    },

    getAcsSubjectSelectRules(row) {
      if (!row.options.length) {
        return []
      }

      return [
        (value) =>
          (value != null && value !== '') || this.$t('Обязательное поле'),
      ]
    },

    getAcsSelectedGrade(row) {
      const grade = getAcsGradeModalSelectedGrade(row)
      return grade !== '' && grade != null ? grade : '—'
    },

    async setAcsGrades() {
      const acsGradeForm = this.$refs.acsGradeForm

      if (!acsGradeForm || !acsGradeForm.validate()) {
        return
      }

      this.acsGradeActionIsLoading = true

      try {
        const payload = buildGradeAcsOrderPayload(
          this.requestQualificationId,
          this.acsGradeSubjects,
        )

        const response = await this.$http.post('/acs-save', payload)

        this.closeAcsGradeDialog()
        this.requestQualificationId = null

        await this.fetchRequest()

        this.$store.dispatch('alertAdd', {
          text: response.data.message,
          type: 'success',
        })

      } catch (e) {
        console.error(e)
      } finally {
        this.acsGradeActionIsLoading = false
      }
    },

    getGradesByType(type) {
      const all = this.metadata.grade

      const range = type === 2 ? [0, 1, 2] : [2, 3, 4, 5]

      return range.map((i) => ({
        text: type === 2 ? all[i] : i,
        value: i,
      }))
    },
  },
}
</script>

<style scoped>
.card-title-custom {
  font-size: 15px;
  background-color: #f5f5f5;
  line-height: 1;
}
.card-text-custom {
  font-size: 15px;
  color: #666;
}
.request-data .v-expansion-panel-header {
  background-color: #f5f5f5;
  min-height: initial;
  font-weight: 500;
}
.request-data .row + .row {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
.prop-title {
  font-size: 15px;
}

.request-card {
  font-size: 15px;
  color: #000;
  margin-bottom: 15px;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  background: #f5f5f5;
  color: #000;
}

.label {
  font-weight: 500;
  color: #000;
}

.dialog-card {
  height: 85vh;
  display: flex;
  flex-direction: column;
}

.dialog-exam-card {
  height: 60vh;
  display: flex;
  flex-direction: column;
}

.v-card__text {
  flex: 1;
  overflow: hidden;
}

.grades-panel {
  height: 100%;
  overflow-y: auto;
  min-height: 0;
  overscroll-behavior: contain;
}

.document-panel {
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.dialog-body {
  flex: 1;
  display: flex;
  overflow: hidden;
}

.dialog-body > .v-row {
  flex: 1;
  min-height: 0;
}
</style>
